module.exports = __webpack_public_path__ + "img/zaak.6526166d.png";